
interface GameMapPathProps {
  fromLeft: boolean
  toLeft: boolean
  isCompleted: boolean
}

export function GameMapPath({ fromLeft, toLeft, isCompleted }: GameMapPathProps) {
  /**
   * Draw a bezier curve from the previous node position to the next.
   * We use a viewBox of 240x80. The "from" point is centered on the
   * previous node column, the "to" point on the next node column.
   *
   * isLeft true  => x ~60  (left offset)
   * isLeft false => x ~180 (right offset)
   */
  const fromX = fromLeft ? 60 : 180
  const toX = toLeft ? 60 : 180

  /** Control points create a smooth S-curve */
  const cp1X = fromX
  const cp1Y = 55
  const cp2X = toX
  const cp2Y = 25

  const d = `M ${fromX} 0 C ${cp1X} ${cp1Y}, ${cp2X} ${cp2Y}, ${toX} 80`

  return (
    <svg
      viewBox="0 0 240 80"
      width="240"
      height="80"
      overflow="visible"
      style={{ display: "block", margin: "0 auto" }}
    >
      <path
        d={d}
        fill="none"
        stroke={isCompleted ? "#10b981" : "#cbd5e1"}
        strokeWidth={isCompleted ? 3 : 2}
        strokeDasharray={isCompleted ? "none" : "6 4"}
        strokeLinecap="round"
      />
    </svg>
  )
}
